import React from 'react'

const Ean = ({ ean, additionalEans = '' }) => {
  const eans = [ean, ...additionalEans.split(',')].filter(Boolean)
  if (!eans.length) return null

  return (
    <div className='mt2'>
      EAN:
      <ul className='eans-list'>
        {eans.map(ean => (
          <li key={ean}>{ean}</li>
        ))}
      </ul>
    </div>
  )
}

export default Ean
